import API from "@/api.js"

export async  function getMenuTree(platform){
	console.log('platform',platform)
	try {
		let res = await API.get(
		  API.admin.getMenuTree + "?platform=" + platform
		)
		return res
	}
	catch(err){
		return []
	}
} 
export async  function addMenu(from){
	try {
		let res=await API.post(API.admin.postMenuAdd,from)
		return res
	}
	catch(err){
		return []
	}
} 
export async  function updateMenu(from){
	try {
		let res=await API.post(API.admin.postMenuUpdate,from)
		return res
	}
	catch(err){
		return []
	}
} 
export async  function delMenu(id){
	try {
		let res=await API.post(API.admin.getMenuDelete,{id})
		return res
	}
	catch(err){
		return []
	}
} 

export async  function authBusiness(from){
	try {
		let res=await API.post(API.admin.postBusinessAuth,from)
		return res
	}
	catch(err){
		return []
	}
} 

export async  function getBusinessList(menuCode){
	try {
		let res=await API.get(API.admin.getBusinessList,{menuCode})
		return res
	}
	catch(err){
		return []
	}
} 

export async  function delBusinessAuth(id){
	try {
		let res=await API.post(API.admin.postBusinessDelete,{id})
		return res
	}
	catch(err){
		return []
	}
} 
export async  function btnList(){
	try {
		let res=await API.get(API.admin.getButtonList)
		return res
	}
	catch(err){
		return []
	}
} 
export async  function addBtn(form){
	try {
		let res=await API.post(API.admin.postButtonAdd,form)
		return res
	}
	catch(err){
		return false
	}
} 
export async  function updateBtn(form){
	try {
		let res=await API.post(API.admin.postButtonUpdate,form)
		return res
	}
	catch(err){
		return false
	}
} 
export async  function delBtn(id){
	console.log('id',id)
	try {
		let res=await API.post(API.admin.getButtonDelete,{id})
		return res
	}
	catch(err){
		return []
	}
} 
export async  function getRoleList(platform){
	try {
		let res=await API.get(API.admin.getRoleList,{platform})
		return res
	}
	catch(err){
		return []
	}
} 
export async  function addRole(from){
	try {
		let res=await API.post(API.admin.postRoleAdd,from)
		return res
	}
	catch(err){
		return []
	}
} 
export async  function updateRole(from){
	try {
		let res=await API.post(API.admin.postRoleUpdate,from)
		return res
	}
	catch(err){
		return []
	}
} 
export async  function delRole(){
	try {
		let res=await API.post(API.admin.postRoleUpdate,from)
		return res
	}
	catch(err){
		return []
	}
} 
export async  function getChecked(roleId){
	try {
		let res=await API.get(API.admin.getRoleMenuCodes,{roleId})
		return res
	}
	catch(err){
		return []
	}
}
 export async function getMenuBusinessList(platform){
	 try {
	 	let res=await API.get(API.admin.getMenuBusinessList,{platform})
	 	return res
	 }
	 catch(err){
	 	return []
	 }
 }
export async  function authRole(roleId,newMenuCodeList){
	try {
		
		let res=await API.post(API.admin.postRoleMenuAuth,{
			roleId,
			newMenuCodeList
		})
		return res
	}
	catch(err){
		return []
	}
} 

